const features = [
  {
    icon: "ri-truck-line",
    title: "Delivered to Your Door",
    desc: "No warehouse trips. Everything ships straight to your home — because your time matters.",
  },
  {
    icon: "ri-battery-2-charge-line",
    title: "Silent, Clean Backup Power",
    desc: "No fumes. No loud engines. Just quiet, reliable energy when your family needs it most.",
  },
  {
    icon: "ri-home-gear-line",
    title: "Portable to Whole-Home",
    desc: "Whether it's a single room or your entire house, we have a solution that fits your life.",
  },
  {
    icon: "ri-shield-check-line",
    title: "No Hype — Just Real Gear",
    desc: "We only carry equipment we'd trust in our own home. If it doesn't hold up, we don't sell it.",
  },
];

export default function TrustBar() {
  return (
    <section className="bg-gray-950 text-white py-12">
      <div className="max-w-6xl mx-auto px-4 md:px-6 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {features.map((f) => (
          <div key={f.title} className="flex flex-col items-center text-center gap-3">
            <div className="w-12 h-12 flex items-center justify-center bg-amber-500/10 rounded-full">
              <i className={`${f.icon} text-amber-400 text-2xl`}></i>
            </div>
            <div>
              <p className="font-semibold text-sm text-white">{f.title}</p>
              <p className="text-xs text-gray-400 mt-1 leading-relaxed">{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
